
import FunnelQuestions from './FunnelQuestions'

export default {
  name: 'FinalQuestions',
  functional: true,
  render(createElement, context) {
    return createElement(FunnelQuestions, {
      ...context.data,
      key: 'final',
      props: { ...context.props, nature: 'final' }
    })
  }
}
